export const getDataListValueFields = (
  value: string | undefined | null,
  options: { fallbackValue: string; fallbackAriaLabel?: string }
) => ({
  value: value || options.fallbackValue,
  ariaLabelValue: value ? undefined : options.fallbackAriaLabel,
})
